export const SMART_BUSINESS_SIGNUP_MOCK = {
  generateBrandedCoins: {
    images: [
      'https://twism-testing.imgix.net/images/ai-core/runtimes/1734361707973-j15yis6rawg.png?w=600&h=600&format=PNG&s=81ba4cef48cd53920fb3e7c36c2f23fb',
      'https://twism-testing.imgix.net/images/ai-core/runtimes/1734361707821-rtdbmz8y49c.png?w=600&h=600&format=PNG&s=26c83ae94ad7ac8e035951786eb140ca',
      'https://twism-testing.imgix.net/images/ai-core/runtimes/1734361708342-n5um8qmp6.png?w=600&h=600&format=PNG&s=3f90a94f503d0ac05e3b5f27b0cca133'
    ]
  },
  loyaltyAndGiftPercentageRecommendation: {
    loyaltyPercentage: 5.0,
    giftPercentage: 10.0
  },
  offersRecommendation: {
    offers: [
      {
        title: 'Avocado Toast Delight',
        description:
          'Savor our famous avocado toast paired with a freshly brewed coffee for a delightful breakfast experience for just $5.00.',
        type: 'ProductAndService',
        special_type: 'ProductAndService',
        member_limit: '20',
        original_price: 6.5,
        discount_type: '$',
        discount_value: 1.5,
        image_url:
          'https://twism-testing.imgix.net/images/ai-core/runtimes/1734457035192-b023489b-2971-4ed7-a345-32cb19b62df9.png?w=600&h=600&format=PNG&s=4c13e8300b5f336c66b711e78be81d66',
        restrictions:
          'This offer is not valid on weekends (Saturday and Sunday).'
      },
      {
        title: 'Birthday Brew Bash',
        description:
          'Celebrate your birthday with a complimentary drink of your choice and a special treat on us!',
        type: 'Birthday',
        special_type: 'Birthday',
        image_url:
          'https://twism-testing.imgix.net/images/ai-core/runtimes/1734457034839-a7c26a34-52e2-470b-aa2c-27d93d009b30.png?w=600&h=600&format=PNG&s=ed16ffcf1d2131eda45613fa95f74de9'
      },
      {
        title: "Coffee Lovers' Special",
        description:
          'Enjoy 20% off all coffee drinks for a limited time. Perfect for your daily caffeine fix!',
        type: 'General',
        special_type: 'Storewide',
        member_limit: '50',
        discount_code: 'COFFEE20',
        image_url:
          'https://twism-testing.imgix.net/images/ai-core/runtimes/1734457034889-f70972f7-eaa7-4e52-925c-8cd3bcedf446.png?w=600&h=600&format=PNG&s=980149428348dafee2058f8a827d54a9'
      }
    ]
  }
};

export const DEFAULT_BRANDED_COIN_IMAGE = 'default-branded-coin';
export const DEFAULT_ERROR_RESPONSE = { status: 400 };
